if (!customElements.get('product-price')) {
  customElements.define(
    'product-price',
    class ProductPrice extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initializeProductSwapUtility();
      }

      initializeProductSwapUtility() {
        const productId = this.getAttribute('data-product-id');
        const productData = window.modalInquiredByPrice[`product_${productId}`];
        const available = window.modalByAvailable.isAvailable;

        if (productData?.hidePrice || !available) {
          this.hidePrice();
        }
      }

      // TODO: warning added due to console error, price element not found on collection pages. Please note and improve this
      hidePrice = () => {
        const priceEl = this.querySelector('.price');
        if (priceEl) {
          priceEl.classList.add('hidden');
        } else {
          console.warn("Element .price not found");
        }
      };
    }
  );
}
